export default "__VITE_ASSET__0890c9cf__"